import React from "react";
import { Image, Modal } from "react-bootstrap";
import "./dialogModal.css";
import MainButton from "../buttons/main_button/MainButton";
import iconAlert from '../../resources/images/ic-alert-modal.svg';
import warningIcon from '../../resources/images/warning-circle.svg';
import closeIcon from '../../resources/images/close_new.svg';
import iconError from '../../resources/images/ic-error-modal.svg';
import iconCamera from '../../resources/images/ic-camera-modal.svg';
import iconAlertRed from '../../resources/images/alert-icons/alert-icon-12.svg';
import clockIcon from '../../resources/images/clock-icon.svg';
import { ReactComponent as IconCheck } from '../../resources/images/check-v2.svg';

const capitalizeFirstLetter = (text) => {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
};

const renderMessage = (message, className = '') => {
    if (!message) return null;

    if (Array.isArray(message)) {
        return message.map((msg, index) => (
            <div key={index} className={className}>
                <div className="container-tips">
                    <div className="icon">
                        <IconCheck />
                    </div>
                    <div className="text">{msg}</div>
                </div>
            </div>
        ));
    }

    if (typeof message === 'object') {
        return <div className={className}>{JSON.stringify(message)}</div>;
    }

    return <div className={className} dangerouslySetInnerHTML={{ __html: message }} />;
};

const DialogModal = ({ isVisible, title, principalMessage, secondaryMessage, tertiaryMessage, tips, type, buttons, onClose, classModal, withSubtitle = true }) => {
    if (!isVisible) return null;
    const iconType = {
        'warningRed': <Image style={{ width: '22px', height: '22px' }} src={iconAlertRed} />,
        'warning': <Image src={warningIcon} />,
        'error': <Image src={iconError} />,
        'camera': <Image  src={iconCamera} />,
        'alert-orange': <Image src={iconAlert} />,
        'unauthorized': <Image src={clockIcon} />
    }
    return (
        <Modal
            show={isVisible}
            onHide={onClose}
            className={classModal ? classModal : 'dialog-modal'}
        >
            <Modal.Header>
                <div className={'container-title-modal'}>
                    <div className="title-icon">
                        {iconType[type] || iconType['warning']}
                    </div>
                    <div className="title-text">
                        <Modal.Title>{capitalizeFirstLetter(title)}</Modal.Title>
                    </div>
                    <div className="title-close" onClick={onClose}>
                        <Image src={closeIcon} />
                    </div>
                </div>
            </Modal.Header>
            <Modal.Body className="p-4">
                {renderMessage(principalMessage, withSubtitle ? 'subtitle' : '')}
                {renderMessage(secondaryMessage)}
                {renderMessage(tips)}
                {renderMessage(tertiaryMessage, 'tertiary-message')}
            </Modal.Body>
            <Modal.Footer>
                {buttons || <MainButton onClick={onClose} text="Cerrar" />}
            </Modal.Footer>
        </Modal>
    );
};

export default DialogModal;
